import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { commonStrings } from "../../../core";
import noDataImage from "../../../dist/images/core/montacar-no-data.png";

export interface INoDataComponent {
    invitation?: boolean;
}

export const NoDataComponent: React.FC<INoDataComponent> = ({ invitation }) => {
    const navigate = useNavigate();
    const strings = commonStrings()['PTBR'].core.noData;

    const handlerNoData = () => {
        if (invitation) navigate('/subscription');
    }
    return (
        <div onClick={() => handlerNoData()}>
            <Row>
                <Col sm={12} className="text-center" style={{ marginBottom: "-50px" }}>
                    <h1>{strings.description}</h1>
                </Col>
                <Col className="d-flex justify-content-center">
                    <Image src={noDataImage} width={300} />
                </Col>
                {invitation &&
                    <Col sm={12} className="text-center">
                        <a href="#">{strings.invitation}</a>
                    </Col>
                }
            </Row>

        </div>
    )
}